/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
import { olMap } from 'components/Map/ControlMap/index';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { getMaxZIndex } from 'store/actions/mapActions';
import { Style, Fill, Stroke, Icon } from 'ol/style';
import { getLayerByName } from '../../mapActions';

const style = new Style({
	fill: new Fill({
		color: 'rgba(0, 128, 255, 0.3)'
	}),
	stroke: new Stroke({
		color: 'rgba(0, 128, 255, 0.8)',
		lineDash: [10, 10],
		width: 3
	}),
	image: new Icon({
		crossOrigin: 'anonymous',
		src: 'assets/icons/svg/drawplus.svg'
	})
});

export const vectorsMeasure =
	({ dataMap }) =>
	async () => {
		const lastZIndex = getMaxZIndex() + 2;

		const vectorDataMeasure = new VectorLayer({
			name: dataMap.name,
			source: new VectorSource({ wrapX: false }),
			monitoring: false,
			label: dataMap.label,
			haveTitle: false,
			zIndex: lastZIndex,
			style
		});

		const layerdataUsersWebGis = await getLayerByName(dataMap.name);

		// pq senão dá problemas de interação com mapa, por exemplo, adicionar ou remover pontos
		if (!layerdataUsersWebGis) olMap().addLayer(vectorDataMeasure);
	};
